import { render, staticRenderFns } from "./new-equipment-gallery.vue?vue&type=template&id=0bd52c46&scoped=true"
import script from "./new-equipment-gallery.vue?vue&type=script&lang=js"
export * from "./new-equipment-gallery.vue?vue&type=script&lang=js"
import style0 from "./new-equipment-gallery.vue?vue&type=style&index=0&id=0bd52c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd52c46",
  null
  
)

export default component.exports